import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { AddCredit } from './../interfaces/add-credit';
import { ChangeFeePlan } from './../interfaces/change-fee-plan';
import { MakeQuickPayment } from './../interfaces/make-quick-payment';
import { ScholarshipInformation } from './../interfaces/scholarship-information';
import { PlayerDiscount } from './../interfaces/player-discount';
import { PaymentPlans } from './../interfaces/payment-plans';
import { UpdatePaymentPlan } from './../interfaces/update-payment-plan';
import { LogPayment } from './../interfaces/log-payment';
import { FeeNameList } from '../interfaces/fee-name-list';
import { HttpService } from './http.service';
import { CardDetail } from '../models/user/card-detail';
import * as lodash from 'lodash';

@Injectable()
export class PlayerAdjustmentService {
  private _url = '/api/ClubUserProgramFee';
  private _feeUrl = '/api/Fees';

  public updatePaymentPlanUrl: string;
  public scholarshipInfoUrl: string;
  public playerDiscountUrl: string;
  public addCreditUrl: string;
  public logPaymentUrl: string;

  constructor(
    private http: HttpClient,
    private httpService: HttpService
  ) {
    this.logPaymentUrl = `${this._url}/clubuserlogpayment`;
    this.scholarshipInfoUrl = `${this._url}/addclubuserscholarship`;
    this.playerDiscountUrl = `${this._url}/addclubuserplayerdiscount`;
    this.addCreditUrl = `${this._url}/addclubuserprogramcredit`;
  }

  saveFeePlan(changeFeePlan: ChangeFeePlan) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    const UserProgramFeeID = changeFeePlan.ClubUserProgramFeeID;
    const ProgramFeeID = changeFeePlan.ClubProgramFeeID;
    const AdminID = changeFeePlan.AdminID;
    const url = `${this._url}/update-fee-plan/${UserProgramFeeID}/${ProgramFeeID}/${AdminID}`;
    return this.http.put(url, httpOptions);
  }

  saveLogPayment(logPayment: LogPayment) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this.logPaymentUrl, logPayment, httpOptions);
  }

  // Player Discount
  savePlayerDiscount(playerDiscount: PlayerDiscount) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this.playerDiscountUrl, playerDiscount, httpOptions);
  }

  // Add Credit
  saveCredit(addCredit: AddCredit) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this.addCreditUrl, addCredit, httpOptions);
  }

  saveTravelCredit(addCredit) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(`${this._url}/addclubuserprogramcredit-travel`, addCredit, httpOptions);
  }

  saveScholarshipInformation(scholarshipInformation: ScholarshipInformation) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this.scholarshipInfoUrl, scholarshipInformation, httpOptions);
  }

  // TODO: check API
  updatePaymentPlan(updatePaymentPlan: UpdatePaymentPlan) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    this.updatePaymentPlanUrl = `${this._url}/updateclubuserpaymentplan/${updatePaymentPlan.clubUserProgramFeeID}`;
    return this.http
      .put(this.updatePaymentPlanUrl, JSON.stringify(updatePaymentPlan), httpOptions);
  }

  getPaymentPlans(clubUserProgramFeeID: string) {
    return this.http.get<PaymentPlans[]>(this._url + '/clubuserpaymentplan/' + clubUserProgramFeeID).pipe(map(res => res.filter(x => x.amount)));
  }

  getClubUserPaymentPlans(clubUserProgramFeeID: number) {
    return this.httpService.get(this._url + '/get-clubuserpaymentplans/' + clubUserProgramFeeID).pipe(map(res => res.filter(x => x.amount)));
  }

  getAllClubUserPaymentPlans(clubUserProgramFeeID: number) {
    return this.httpService.get(this._url + '/get-all-clubuserpaymentplans/' + clubUserProgramFeeID).pipe(
      map(res => lodash.sortBy(res, 'dueDate'))
    );
  }

  updateClubUserPaymentPlans(clubUserProgramFeeID: number, data: any) {
    console.log(data);
    return this.httpService.post(this._url + '/update-clubuserpaymentplans/' + clubUserProgramFeeID, data);
  }

  // TODO: change API.
  getPaymentPlansNew(clubUserProgramFeeID: string) {
    return this.http.get<PaymentPlans[]>(this._url + '/clubuserpaymentplanNew/' + clubUserProgramFeeID);
  }

  getFees(programId: string): Observable<FeeNameList[]> {
    return this.http.get<FeeNameList[]>(this._feeUrl + '/feeNames/' + programId);
  }

  getSavedCardsDetails(userId: number) {
    return this.httpService.get(`${this._url}/getSavedCardsDetails/${userId}`).pipe(map(res =>
      (res || []).map(c => new CardDetail(c))
    ));
  }

  getActiveUserCardID(clubUserProgramFeeID: number) {
    return this.httpService.get(`${this._url}/getActiveCardID/${clubUserProgramFeeID}`);
  }

  deactivatedUserCardID(clubUserProgramFeeID: number) {
    return this.httpService.put(`${this._url}/deactivatedUserCardID/${clubUserProgramFeeID}`);
  }

  changeUserCard(clubUserProgramFeeID: number, cardId: number) {
    return this.httpService.put(`${this._url}/changeUserCard/${clubUserProgramFeeID}/${cardId}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/player-adjustment.service.ts